import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "camarca_admin_token";

const AuthContext = createContext(null);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined);

    const getToken = () => localStorage.getItem(TOKEN_KEY);

    const authHeaders = useCallback(() => {
        const token = getToken();
        return token ? { Authorization: `Bearer ${token}` } : {};
    }, []);

    useEffect(() => {
        const token = getToken();
        if (!token) {
            setUser(null);
            return;
        }
        axios
            .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
            .then(({ data }) => setUser(data))
            .catch(() => {
                localStorage.removeItem(TOKEN_KEY);
                setUser(null);
            });
    }, []);

    const login = async (email, password) => {
        const { data } = await axios.post(`${API}/auth/login`, { email, password });
        localStorage.setItem(TOKEN_KEY, data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        localStorage.removeItem(TOKEN_KEY);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, authHeaders }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
